// Loan-to-value figures for the loan file header and the Loan & Property tab.
// Value is the lesser of price and appraisal on a purchase, the appraisal on a
// refinance. CLTV adds closed-end subordinate financing; HCLTV also adds the
// full credit limit of any HELOC (not just what is drawn).

const num = (v) => Number(v) || 0;

export function propertyValue({ loan_purpose: purpose, purchase_price: price, appraised_value: appraised }) {
  const p = num(price);
  const a = num(appraised);
  if (purpose === 'purchase' && p && a) return Math.min(p, a);
  return a || p || 0;
}

const pct = (amount, value) => (value ? Math.round((amount / value) * 1000) / 10 : null);

export function ltvStack(loan) {
  const value = propertyValue(loan);
  const base = num(loan.loan_amount);
  const sub = num(loan.subordinate_financing);
  const heloc = num(loan.heloc_credit_limit);
  return {
    ltv: pct(base, value),
    cltv: pct(base + sub, value),
    hcltv: pct(base + sub + heloc, value),
  };
}
